import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { InformesService } from 'app/services/informes.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-notas-seguimiento',
  templateUrl: './notas-seguimiento.component.html',
  styleUrls: ['./notas-seguimiento.component.scss']
})
export class NotasSeguimientoComponent implements OnInit {

  public notaSeguimiento: string;

  constructor(@Inject(MAT_DIALOG_DATA) private datos, private _informe: InformesService, private _snackBar: MatSnackBar, private _dialog: MatDialogRef<NotasSeguimientoComponent>) {
    if(this.datos.apoyoUsuSegui == null || this.datos.apoyoUsuSegui == ''){
      this.notaSeguimiento = "Sin Notas de Seguimiento";
    }else{
      this.notaSeguimiento = this.datos.apoyoUsuSegui;
    }
  }

  ngOnInit() { 
  }

  public guardarSeguimiento(){

    let response:Object = {
      tipo: 'nSegui',
      indice: this.datos.indice,
      notas: this.notaSeguimiento
    } 

    this._informe.GuardarSeguimiento(this.datos.idApoyo, this.notaSeguimiento).subscribe((data:any) => {
      if(data.estatus == 1){
        this._snackBar.open('Se ha guardado la auditoría.', 'Aceptar', {
          duration: 2000
        });
        this._dialog.close(response);
      }else{
        this._snackBar.open('Error al guardar la auditoría', 'Aceptar', {
          duration: 2000
        });
      }
    })

  }

}
